import {
    GET_STICKERS_PENDING,
    GET_STICKERS_FULFULLED,
    GET_STICKERS_REJECTED,
    GET_STICKER_PENDING,
    GET_STICKER_FULFULLED,
    GET_STICKER_REJECTED,
    DELETE_STICKER_PENDING,
    DELETE_STICKER_FULFILLED,
    DELETE_STICKER_REJECTED,
    CREATE_STICKER_PENDING,
    CREATE_STICKER_FULFILLED,
    CREATE_STICKER_REJECTED,
    ADD_SEGMENT_TO_STICKER_PENDING,
    ADD_SEGMENT_TO_STICKER_FULFILLED,
    ADD_SEGMENT_TO_STICKER_REJECTED,
    REMOVE_SEGMENT_FROM_STICKER_PENDING,
    REMOVE_SEGMENT_FROM_STICKER_FULFILLED,
    REMOVE_SEGMENT_FROM_STICKER_REJECTED,
    ADD_EQUIPMENT_TYPES_TO_STICKER_PENDING,
    ADD_EQUIPMENT_TYPES_TO_STICKER_FULFILLED,
    ADD_EQUIPMENT_TYPES_TO_STICKER_REJECTED,
    REMOVE_EQUIPMENT_TYPE_FROM_STICKER_PENDING,
    REMOVE_EQUIPMENT_TYPE_FROM_STICKER_FULFILLED,
    REMOVE_EQUIPMENT_TYPE_FROM_STICKER_REJECTED
} from '../actions/StickerActions';

// INITIALIZE STATE
const initialState = {
    stickers: [],
    sticker: {},
    fetchingStickers: false,
    fetchedStickers: false,
    failedStickers: false,
    fetchingSticker: false,
    fetchedSticker: false,
    failedSticker: false,
    deletingStickers: false,
    uploadingSticker: false,
    uploadedSticker: false,
    deletedSticker: false,
    addingSegmentToSticker: false,
    addedSegmentToSticker: false,
    addSegmentToStickerFailed: false,
    removingSegmentFromSticker: false,
    removedSegmentFromSticker: false,
    removeSegmentFromStickerFailed: false,
    addingEquipmentTypesToSticker: false,
    addedEquipmentTypesToSticker: false,
    addEquipmentTypesToStickerFailed: false,
    removingEquipmentTypesFromSticker: false,
    removedEquipmentTypesFromSticker: false,
    removeEquipmentTypesFromStickerFailed: false
};

export const StickerReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_STICKERS_PENDING:
            return {
                ...state,
                fetchingStickers: true,
                fetchedStickers: false,
                failedStickers: false
            };
        case GET_STICKERS_FULFULLED:
            return {
                ...state,
                stickers: action.payload,
                fetchingStickers: false,
                fetchedStickers: true,
                failedStickers: false,
            };
        case GET_STICKERS_REJECTED:
            return {
                ...state,
                fetchingStickers: false,
                fetchedStickers: false,
                failedStickers: true,
            };
        case GET_STICKER_PENDING:
            return {
                ...state,
                sticker: {},
                fetchingSticker: true,
                fetchedSticker: false,
                failedSticker: false
            };
        case GET_STICKER_FULFULLED:
            return {
                ...state,
                sticker: action.payload,
                fetchingSticker: false,
                fetchedSticker: true,
                failedSticker: false
            };
        case GET_STICKER_REJECTED:
            return {
                ...state,
                fetchingSticker: false,
                fetchedSticker: false,
                failedSticker: true
            };
        case DELETE_STICKER_PENDING:
            return {
                ...state,
                deletingSticker: true,
                deletedSticker: false,
                rejected: false
            };
        case DELETE_STICKER_FULFILLED: {
            let stickers = state.stickers.filter(item => item.id !== action.payload);
            return {
                ...state,
                stickers: stickers,
                deletingSticker: false,
                deletedSticker: true,
                rejected: false
            };
        }
        case DELETE_STICKER_REJECTED:
            return {
                ...state,
                deletingSticker: false,
                deletedSticker: false,
                failedStickers: true,
            };
        case CREATE_STICKER_PENDING:
            return {
                ...state,
                uploadingSticker: true,
                uploadedStickers: false,
                rejected: false,
            };
        case CREATE_STICKER_FULFILLED:
            return {
                ...state,
                uploadedStickers: true,
                uploadingSticker: false,
                rejected: false
            };
        case CREATE_STICKER_REJECTED:
            return {
                ...state,
                uploadedStickers: false,
                uploadingSticker: false,
                rejected: true
            };
        case ADD_SEGMENT_TO_STICKER_PENDING: 
            return {
                ...state,
                addingSegmentToSticker: true,
                addedSegmentToSticker: false,
                addSegmentToStickerFailed: false
            };
        case ADD_SEGMENT_TO_STICKER_FULFILLED: {
            let sticker = JSON.parse(JSON.stringify(state.sticker));
            if(sticker != {}){
                for(let segment of action.payload.segmentIds){
                    if (sticker.segments == undefined || sticker.segments == null) {
                        sticker.segments = {};
                        sticker.segments[segment] = true;
                    } else {
                        sticker.segments[segment] = true;
                    }
                }
            }
            return {
                ...state,
                sticker: sticker,
                addingSegmentToSticker: false,
                addedSegmentToSticker: true,
                addSegmentToStickerFailed: false
            };
        }
        case ADD_SEGMENT_TO_STICKER_REJECTED:
            return {
                ...state,
                addingSegmentToSticker: false,
                addedSegmentToSticker: false,
                addSegmentToStickerFailed: true
            };
        case REMOVE_SEGMENT_FROM_STICKER_PENDING:
            return {
                ...state,
                removingSegmentFromSticker: true,
                removedSegmentFromSticker: false,
                removeSegmentFromStickerFailed: false
            };
        case REMOVE_SEGMENT_FROM_STICKER_FULFILLED: {
            let sticker = JSON.parse(JSON.stringify(state.sticker));
            if(sticker.segments != undefined) {
                delete sticker.segments[action.payload.segmentId];
            }
            return {
                ...state,
                sticker: sticker,
                removingSegmentFromSticker: false,
                removedSegmentFromSticker: true,
                removeSegmentFromStickerFailed: false
            };
        }
        case REMOVE_SEGMENT_FROM_STICKER_REJECTED:
            return {
                ...state,
                removingSegmentFromSticker: false,
                removedSegmentFromSticker: false,
                removeSegmentFromStickerFailed: true
            };

        case ADD_EQUIPMENT_TYPES_TO_STICKER_PENDING:
            return {
                ...state,
                addingEquipmentTypesToSticker: true,
                addedEquipmentTypesToSticker: false,
                addEquipmentTypesToStickerFailed: false,
            };
        case ADD_EQUIPMENT_TYPES_TO_STICKER_FULFILLED: {
            let sticker = JSON.parse(JSON.stringify(state.sticker));
            sticker.equipmentTypes = action.payload.equipmentTypes;
            console.log(sticker);
            return {
                ...state,
                sticker: sticker,
                addingEquipmentTypesToSticker: false,
                addedEquipmentTypesToSticker: true,
                addEquipmentTypesToStickerFailed: false,
            };
        }
        case ADD_EQUIPMENT_TYPES_TO_STICKER_REJECTED:
            return {
                ...state,
                addingEquipmentTypesToSticker: false,
                addedEquipmentTypesToSticker: false,
                addEquipmentTypesToStickerFailed: true,
            };
        case REMOVE_EQUIPMENT_TYPE_FROM_STICKER_PENDING:
            return {
                ...state,
                removingEquipmentTypesFromSticker: true,
                removedEquipmentTypesFromSticker: false,
                removeEquipmentTypesFromStickerFailed: false
            };
        case REMOVE_EQUIPMENT_TYPE_FROM_STICKER_FULFILLED: {
            let sticker = JSON.parse(JSON.stringify(state.sticker));
            if(sticker.equipmentTypes == undefined ) {
                sticker.equipmentTypes = [];
            }
            sticker['equipmentTypes'] = action.payload.equipmentTypes;
            return {
                ...state,
                sticker: sticker,
                removingEquipmentTypesFromSticker: false,
                removedEquipmentTypesFromSticker: true,
                removeEquipmentTypesFromStickerFailed: false
            };
        }
        case REMOVE_EQUIPMENT_TYPE_FROM_STICKER_REJECTED:
            return {
                ...state,
                removingEquipmentTypesFromSticker: false,
                removedEquipmentTypesFromSticker: false,
                removeEquipmentTypesFromStickerFailed: false
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/components/state/reducers/StickerReducer.js